import { render, staticRenderFns } from "./SearchNotFound.vue?vue&type=template&id=ff894910"
import script from "./SearchNotFound.vue?vue&type=script&lang=js"
export * from "./SearchNotFound.vue?vue&type=script&lang=js"
import style0 from "./SearchNotFound.vue?vue&type=style&index=0&id=ff894910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports